import React, { Component } from "react";
import ApiConnect from "../../../../Utils/ApiConnect";
import AnimatedNumber from "animated-number-react";
import { connect } from "react-redux";
import { setTodayInfo } from "../../../../redux/actions/Modules.Action";
class TodayInfo extends Component {
  FetchTodaysInfo = async () => {
    try {
      ApiConnect.get(`POS/Report/TodayInfoSummary?from=&to=`)
        .then((response) => {
          if (response.data.status === 200) {
            this.props.setTodayInfo(response.data.data);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (err) {
      console.log("error facing location:", err);
    }
  };
  componentDidMount = async () => {
    this.FetchTodaysInfo();
  };
  CalculateToPer(highest, current) {
    let per = (parseFloat(current) * 100) / parseFloat(highest);
    return per || 0;
  }
  formatValue = (value) => `${Number(value).toFixed()}`;
  render() {
    const TodayData = this.props.todayData;
    return (
      <React.Fragment>
        <div className="col-6 col-lg-3">
          <div className="card shadow-1">
            <div className="card-body">
              <div className="flexbox">
                <h5>Total Sales</h5>
                <div className="dropdown">
                  <span
                    className="dropdown-toggle no-caret"
                    data-toggle="dropdown"
                  >
                    <i className="ti-more-alt rotate-90" />
                  </span>
                  <div className="dropdown-menu dropdown-menu-right">
                    <span className="dropdown-item">
                      <i className="ion-android-list" /> Details
                    </span>
                    <span className="dropdown-item">
                      <i className="ion-android-add" /> Add new
                    </span>
                    <span className="dropdown-item">
                      <i className="ion-android-refresh" /> Refresh
                    </span>
                  </div>
                </div>
              </div>
              <div className="text-center my-2">
                <div className="fs-60 fw-400 text-success">
                  <AnimatedNumber
                    value={TodayData ? TodayData.sales.count : 0}
                    formatValue={this.formatValue}
                  />{" "}
                </div>
                <span className="fw-400 ">
                  Total{" "}
                  <AnimatedNumber
                    value={TodayData ? TodayData.sales.total : 0}
                    formatValue={(value) => `${Number(value).toFixed(2)}`}
                  />{" "}
                </span>
              </div>
            </div>
            <div className="card-body bg-lighter fw-400 py-12">
              <span className=" mr-1">Highest:</span>
              <span className="text-dark">
                <AnimatedNumber
                  value={TodayData ? TodayData.sales.high : 0}
                  formatValue={(value) => `${Number(value).toFixed(2)}`}
                />
              </span>
            </div>
            <div className="progress mb-0">
              <div
                className="progress-bar bg-success"
                role="progressbar"
                style={{
                  width: this.CalculateToPer(
                    TodayData ? TodayData.sales.high : 0,
                    TodayData ? TodayData.sales.total : 0
                  ),
                  height: 3,
                }}
              />
            </div>
          </div>
        </div>
        <div className="col-6 col-lg-3">
          <div className="card shadow-1">
            <div className="card-body">
              <div className="flexbox">
                <h5>Orders</h5>
                <div className="dropdown">
                  <span
                    className="dropdown-toggle no-caret"
                    data-toggle="dropdown"
                  >
                    <i className="ti-more-alt rotate-90" />
                  </span>
                  <div className="dropdown-menu dropdown-menu-right">
                    <span className="dropdown-item">
                      <i className="ion-android-list" /> Details
                    </span>
                    <span className="dropdown-item">
                      <i className="ion-android-add" /> Add new
                    </span>
                    <span className="dropdown-item">
                      <i className="ion-android-refresh" /> Refresh
                    </span>
                  </div>
                </div>
              </div>
              <div className="text-center my-2">
                <div className="fs-60 fw-400 text-info">
                  <AnimatedNumber
                    value={TodayData ? TodayData.orders.count : 0}
                    formatValue={this.formatValue}
                  />
                </div>
                <span className="fw-400 ">
                  Total{" "}
                  <AnimatedNumber
                    value={TodayData ? TodayData.orders.total : 0}
                    formatValue={(value) => `${Number(value).toFixed(2)}`}
                  />
                </span>
              </div>
            </div>
            <div className="card-body bg-lighter fw-400 py-12">
              <span className=" mr-1">Highest:</span>
              <span className="text-dark">
                <AnimatedNumber
                  value={TodayData ? TodayData.orders.high : 0}
                  formatValue={(value) => `${Number(value).toFixed(2)}`}
                />
              </span>
            </div>
            <div className="progress mb-0">
              <div
                className="progress-bar bg-info"
                role="progressbar"
                style={{
                  width: this.CalculateToPer(
                    TodayData ? TodayData.orders.high : 0,
                    TodayData ? TodayData.orders.count : 0
                  ),
                  height: 3,
                }}
                aria-valuenow={25}
                aria-valuemin={0}
                aria-valuemax={100}
              />
            </div>
          </div>
        </div>
        <div className="col-6 col-lg-3">
          <div className="card shadow-1">
            <div className="card-body">
              <div className="flexbox">
                <h5>Tables</h5>
                <div className="dropdown">
                  <span
                    className="dropdown-toggle no-caret"
                    data-toggle="dropdown"
                  >
                    <i className="ti-more-alt rotate-90" />
                  </span>
                  <div className="dropdown-menu dropdown-menu-right">
                    <a className="dropdown-item" href="ticket-single.html">
                      <i className="ion-android-list" /> Details
                    </a>
                    <a className="dropdown-item" href="ticket-add.html">
                      <i className="ion-android-add" /> Add new
                    </a>
                    <a className="dropdown-item" href="ticket-list.html">
                      <i className="ion-android-refresh" /> Refresh
                    </a>
                  </div>
                </div>
              </div>
              <div className="text-center my-2">
                <div className="fs-60 fw-400 text-primary">
                  <AnimatedNumber
                    value={TodayData ? TodayData.table.open : 0}
                    formatValue={this.formatValue}
                  />
                </div>
                <span className="fw-400 ">Open</span>
              </div>
            </div>
            <div className="card-body bg-lighter fw-400 py-12">
              <span className=" mr-1">Closed:</span>
              <span className="text-dark">
                <AnimatedNumber
                  value={TodayData ? TodayData.table.close : 0}
                  formatValue={this.formatValue}
                />
              </span>
            </div>
            <div className="progress mb-0">
              <div
                className="progress-bar"
                role="progressbar"
                style={{
                  width: this.CalculateToPer(
                    TodayData ? TodayData.table.count : 0,
                    TodayData ? TodayData.table.open : 0
                  ),
                  height: 3,
                }}
                aria-valuenow={40}
                aria-valuemin={0}
                aria-valuemax={100}
              />
            </div>
          </div>
        </div>
        <div className="col-6 col-lg-3">
          <div className="card shadow-1">
            <div className="card-body">
              <div className="flexbox">
                <h5>Booking</h5>
                <div className="dropdown">
                  <span
                    className="dropdown-toggle no-caret"
                    data-toggle="dropdown"
                  >
                    <i className="ti-more-alt rotate-90" />
                  </span>
                  <div className="dropdown-menu dropdown-menu-right">
                    <a className="dropdown-item" href="forum-single.html">
                      <i className="ion-android-list" /> Details
                    </a>
                    <a className="dropdown-item" href="forum-add.html">
                      <i className="ion-android-add" /> Add new
                    </a>
                    <a className="dropdown-item" href="forum-list.html">
                      <i className="ion-android-refresh" /> Refresh
                    </a>
                  </div>
                </div>
              </div>
              <div className="text-center my-2">
                <div className="fs-60 fw-400 text-warning">
                  <AnimatedNumber
                    value={TodayData ? TodayData.booking.count : 0}
                    formatValue={this.formatValue}
                  />
                </div>
                <span className="fw-400 ">
                  Total{" "}
                  <AnimatedNumber
                    value={TodayData ? TodayData.booking.total : 0}
                    formatValue={this.formatValue}
                  />
                </span>
              </div>
            </div>
            <div className="card-body bg-lighter fw-400 py-12">
              <span className=" mr-1">Dispatch:</span>
              <span className="text-warning">
                <AnimatedNumber
                  value={TodayData ? TodayData.booking.dispatch : 0}
                  formatValue={this.formatValue}
                />
              </span>
            </div>
            <div className="progress mb-0">
              <div
                className="progress-bar bg-warning"
                role="progressbar"
                style={{
                  width: this.CalculateToPer(
                    TodayData ? TodayData.booking.count : 0,
                    TodayData ? TodayData.booking.high : 0
                  ),
                  height: 3,
                }}
                aria-valuenow={30}
                aria-valuemin={0}
                aria-valuemax={100}
              />
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
export default connect(
  (state) => ({
    todayData: state.Dashboard.todayInfo,
  }),
  { setTodayInfo }
)(TodayInfo);
